export default __webpack_public_path__ + "static/media/total-members.ade3b941.webp";